/**
 * Detects whether the viewport is currently at a "mobile" width.
 * Uses matchMedia so it stays in sync as the user rotates the device
 * or resizes the browser.
 */
import { useEffect, useState } from "react";

export function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const get = () => (typeof window === "undefined" ? false : window.matchMedia(query).matches);
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);
  return isMobile;
}
